import CategoryNavigationItem from './CategoryNavigationItem'
import { useShop } from '../../../Providers/ShopProvider'
import useCategoryNavigationTree from '../Hooks/useCategoryNavigationTree'
import useGetProductIndexWithMask from '../../../Components/BasketPage/Hooks/useGetProductIndexWithMask'
import Skeleton from 'react-loading-skeleton'

const CategoryNavigationTree = ({ productIndex, categoryFromParam = -1 }) => {
    const { getProductIndexWithMask } = useGetProductIndexWithMask()
    const { activeCategory, setActiveCategory } = useShop()
    let tmpActiveCategory = categoryFromParam === -1 ? activeCategory : categoryFromParam
    const { categories, isLoadingTree } = useCategoryNavigationTree(tmpActiveCategory, setActiveCategory)

    if (isLoadingTree) {
        return <div>
            <Skeleton height={20} width={150} highlightColor="white" baseColor='#cccaca' />
        </div>
    }
    return (<>
        <div className='col'>
            <div className='row align-items-center'>
                <CategoryNavigationItem
                    item={{ catDescription: "Strona główna" }}
                    active={true}
                    setActiveCategory={setActiveCategory}
                    hideFeatureListFilter={true}
                />
                {categories && categories.map(category => {
                    return <>
                        <div className='col-auto'>{">"}</div>
                        <CategoryNavigationItem
                            item={category}
                            categoriesWithSameLevel={category.subCategories}
                            setActiveCategory={setActiveCategory}
                            hideFeatureListFilter={false}
                        />
                    </>
                })}
                {productIndex && <><div className='col-auto'>{">"}</div> <CategoryNavigationItem item={{ catDescription: getProductIndexWithMask(productIndex) }} hideFeatureListFilter={false} /></>}
            </div>
        </div>
    </>
    )
}

export default CategoryNavigationTree